import { isEmpty } from '@witmetrics/utils/misc';
import { isEmail, strip } from '@witmetrics/utils/strings';
import { API } from '@/api';

export const classes = {
  dialog: 'w-[98vw] max-w-[800px] min-w-[300px]',
  body: 'w-full pt-0 pb-10 overflow-auto text-grey-7 dark:text-mauve-2',
  section:
    'p-4 my-4 border border-grey-3 dark:border-white/10 rounded-lg flex flex-col',
  toggleWrapper: 'flex items-center',
  toggle: 'shrink-0 mr-4',
  linkSection: 'flex items-center mt-12 mb-2',
  links: 'flex items-center',
  textField: 'grow mr-2',
  textArea: 'mt-4 mb-1',
  message: 'text-grey-8 dark:text-mauve-1 font-medium',
  invitesMessage: 'mb-8',
  emailsWrapper: 'flex items-center',
};

export function parseEmails(emails: string) {
  return emails
    .split(',')
    .map((email) => strip(email))
    .filter((email) => !isEmpty(email));
}
export function isSendEnabled(emails: string, previousEmails: string) {
  if (isEmpty(emails) || emails === previousEmails) return false;
  for (const email of parseEmails(emails)) {
    if (!isEmail(email)) return false;
  }
  return true;
}

export function fetchSharedContent(fileId: number) {
  return API.SharedContent.fetchSharedContentByFileId(fileId);
}

export function createSharedContent(fileId: number) {
  // Default to unlocked
  return API.SharedContent.createSharedContent({ fileId, isLocked: false });
}

export function updateSharedContent(sharedContentId: number, enabled: boolean) {
  return API.SharedContent.updateSharedContent(sharedContentId, { enabled });
}

export function updateLockedPassword(
  sharedContentId: number,
  isLocked: boolean,
  password?: string
) {
  return API.SharedContent.updateSharedContent(sharedContentId, {
    isLocked,
    password,
  });
}

export function sendInvites(
  sharedContentId: number,
  emails: string[],
  message?: string
) {
  return API.SharedContent.inviteToSharedContent(
    sharedContentId,
    emails,
    isEmpty(message) ? undefined : message
  );
}
